var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"home criacao"},[(_vm.isPwa)?[_c('b-container',{staticClass:"p-md-0 mb-2",attrs:{"fluid":"lg"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('h1',[_vm._v("Agenda de Estudos")])])])]:_vm._e(),_c('form-inputs')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }